module.exports = __webpack_public_path__ + "img/super.ad651cfe.png";